/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Billing_Disable_DescInputs */



/**
* | output |
* | --- |
* | "No invoices will be created while disabled. Reports keep accumulating." |
*
* @param {Partner_Admin_Billing_Disable_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_billing_disable_desc = /** @type {((inputs?: Partner_Admin_Billing_Disable_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Billing_Disable_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Solange die Abrechnung deaktiviert ist, werden keine Rechnungen erstellt. Die Berichte laufen weiter auf.")
	return /** @type {LocalizedString} */ ("No invoices will be created while disabled. Reports keep accumulating.")
});